import { useEffect } from "react";

const upsertMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

/**
 * Setzt Titel, Beschreibung und Robots-Meta pro Route (Google fuehrt JS aus).
 * noindex=true fuer Bereiche, die nicht in Suchmaschinen auftauchen sollen (z.B. Händlerpreise).
 */
export function useSeo(title, description, noindex = false) {
    useEffect(() => {
        document.title = title;
        if (description) upsertMeta("name", "description", description);
        upsertMeta(
            "name",
            "robots",
            noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1",
        );
    }, [title, description, noindex]);
}
